export default {
    getHexColorFromColorPicker(colorPickerElement) {
        return (
            '#' +
            colorPickerElement.shadowRoot.querySelector(
                '.ui5-color-picker-hex-input'
            ).value
        );
    },
    simplifyColorPickers() {
        Array.from(
            window.document.querySelectorAll('ui5-color-picker')
        ).forEach((colorPicker) => {
            const shadowRoot = colorPicker.shadowRoot;
            const currentColorElement = shadowRoot.querySelector(
                '.ui5-color-picker-current-color'
            );
            currentColorElement.querySelector(
                '.ui5-color-picker-white'
            ).style.display = 'none';
            shadowRoot.querySelector(
                '.ui5-color-picker-rgb-wrapper'
            ).style.display = 'none';
            shadowRoot.querySelector(
                '.ui5-color-picker-alpha-slider'
            ).style.display = 'none';
        });
    },
    manipulateColorPickerMainColor(func) {
        window.document
            .querySelectorAll('ui5-color-picker')
            .forEach((colorPicker) => {
                const mainColor = colorPicker.shadowRoot.querySelector(
                    '.ui5-color-picker-main-color'
                );
                func(mainColor);
            });
    },
};
